import { SpinnerSmall } from 'assets/svgs';
import { FC } from 'react';
import { SPINNER_TESTIDS } from './constants';
import style from './Spinner.style';

interface SpinnerProps {
    fill?: string;
    size?: number;
}

export const Spinner: FC<SpinnerProps> = ({ fill, size }) => {
    const classes = style({ fill, size });
    return (
        <SpinnerSmall
            className={classes.loadingSpinner}
            data-testid={SPINNER_TESTIDS.SPINNER_SMALL}
        />
    );
};
